<template>
    <v-card class="mx-auto" shaped elevation="7" min-height="700px">
        <v-card-title>
            Aseguradora
            <v-spacer></v-spacer>
            <v-btn rounded dark color="primary" @click="dialog=true" v-html="'Nuevo'" />
        </v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-row align="center">
                    <v-col cols="12" sm="12">
                        <formularioComponent :editedItem="objetAseguradora" :formTitle="formTitle"
                            :itemsProvincias="listGeneral.listProvincias" :itemsCantones="listGeneral.listCantonesModal"
                            :itemsEstados="listGeneral.listEstados" :dialog="dialog" />
                    </v-col>
                </v-row>
                <v-row align="center">
                    <v-col cols="12" sm="4" md="4">
                        <v-autocomplete dense label="Provincia" color="textbox" v-model="objAseguradoraSearch.idProvincia"
                            @change="onListarCantones" :items="listGeneral.listProvincias" outlined />
                    </v-col>
                    <v-col cols="12" sm="4"  md="4">
                        <v-autocomplete dense label="Cantón" color="textbox" v-model="objAseguradoraSearch.idCanton"
                            @change="onListarAseguradoras" :items="listGeneral.listCantones" item-value="idCanton"
                            item-text="canton" outlined />
                    </v-col>
                    <v-col cols="12" sm="4"  md="4">
                        <v-autocomplete dense label="Estado" color="textbox" v-model="objAseguradoraSearch.estado"
                            :items="listGeneral.listEstados" item-text="nombre_estado" item-value="id_estado"
                            @change="onListarAseguradoras" outlined></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row align="center">
                    <v-col cols="12" sm="6" />
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="objAseguradoraSearch.search" clearable
                            prepend-inner-icon="search" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="12">
                        <v-data-table :search="objAseguradoraSearch.search" :headers="listGeneral.cabecera"
                            :items="listGeneral.detalle" class="elevation-3">
                            <template v-slot:item.name="{ item }">
                                <v-btn class="ma-2" text icon color="primary" @click="editItem(item)">
                                    <v-icon small>edit</v-icon>
                                </v-btn>
                            </template>
                            
                            <template v-slot:no-results>
                                Tu búsqueda de "<span v-text="objAseguradoraSearch.search"></span>" no arrojó resultados.
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    components:{
      formularioComponent:() => import('@/components/aseguradora/ModalAseguradoraComponent.vue')
    },
    data: () => ({
      listGeneral: {},
      objAseguradoraSearch: {
        opcion: 'L',
        search: '',
        idProvincia: null,
        idCanton: null,
        estado: '1'
      },
      objetAseguradora:{
                          opcion: 'I',
                          estado: '1'
                       },
      dialog: false,
      editedIndex: -1,
    }),
    beforeMount(){
      this.cargaGeneral();
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva Aseguradora' : 'Editar Aseguradora'
      }
    }, 
    methods: {
        cargaGeneral(){
            axios.post(`${BASE_URI}administrador/aseguradora/cargaGeneral`,{})
                .then((response) => {
                    if(_.size(_.get(response,['data','data'],[])) == 0) throw _.get(response,['data','mensaje'],mensajeEstandar.errorPeticion);
                    this.$set(this,'listGeneral',response.data.data);
                    this.objAseguradoraSearch.idProvincia = this.listGeneral.listProvincias[0].value;

                    var objeto = {
                                  opcion         : this.objAseguradoraSearch.opcion,
                                  idProvincia    : this.objAseguradoraSearch.idProvincia,
                                  idEstado       : this.objAseguradoraSearch.estado 
                               };

                    return this.onListar('administrador/canton/listar',objeto,'listCantones')                     
                })
                .then((respuesta) =>{
                    if (_.size(_.get(respuesta,['data','data'],[])) > 0) {
                        this.objAseguradoraSearch.idCanton = respuesta.data.data[0].idCanton;
                        this.onListarAseguradoras();
                    }
                })
                .catch((e) => { 
                    mensajesAlerta(e,'E') 
                });
        },
        onListar(ruta,objeto,lista){
            if(!_.isNull(lista)) this.$set(this.listGeneral,lista,[]);
            return  axios.post(`${BASE_URI}${ruta}`,objeto)
                        .then((respuesta) => {
                            if(respuesta.status != 200 && respuesta.statusText != 'OK') throw  mensajeEstandar.errorPeticion;
                            if(respuesta.data.existeError) throw respuesta.data.mensaje;
                                if (_.size(respuesta.data.data) > 0) {
                                if(!_.isNull(lista))
                                    this.$set(this.listGeneral,lista, respuesta.data.data);
                                }else
                                mensajesAlerta(respuesta.data.mensaje,'I');   
                            return respuesta;                       
                        });
        },
        onListarCantones(e){
            if(!_.isUndefined(e)){
            var objeto = {
                            opcion         : this.objAseguradoraSearch.opcion,
                            idProvincia    : this.objAseguradoraSearch.idProvincia,
                            idEstado       : '1' 
                        };

            this.$set(this.listGeneral,'listCantones',[]);
            return this.onListar('administrador/canton/listar',objeto,'listCantones').catch((e) => { mensajesAlerta(e,'E') });
            }
        },
        onListarAseguradoras: function(e){
            if(!_.isUndefined(e)){
            var objeto = {  
                            opcion        : this.objAseguradoraSearch.opcion,
                            idCanton      : this.objAseguradoraSearch.idCanton,
                            idAseguradora : this.objAseguradoraSearch.idAseguradora,
                            estado        : this.objAseguradoraSearch.estado ,
                            };

            this.$set(this.listGeneral,'detalle',[]);
            this.onListar('administrador/aseguradora/listar',objeto,null)
                .then((respuesta) => {
                if (_.size(respuesta.data.data)>0) {
                    _.forEach(respuesta.data.data,(dato,key) => {
                    this.listGeneral.detalle.push({
                        idAseguradora       : dato['id_aseguradora'],
                        nombre              : dato['aseguradora'],
                        ruc                 : dato['ruc'],
                        representanteLegal  : dato['representante_legal'],
                        celular             : _.size(dato['celular']) ? dato['celular'] : '',
                        telefono            : _.size(dato['telefono']) ? dato['telefono'] : '',
                        idProvincia         : dato['id_provincia'],
                        idCanton            : dato['id_canton'],
                        canton              : dato['canton'],
                        direccion           : dato['direccion'],
                        email               : _.size(dato['email']) ? dato['email'] : '',
                        paginaWeb           : _.size(dato['pagina_web']) ? dato['pagina_web'] : '',
                        path                : dato['path'],
                        estado              : dato['estado']
                    });
                    });                
                }else
                    mensajesAlerta(respuesta.data.mensaje,'I');
                })
                .catch((e) => { mensajesAlerta(e,'E') });
            }
        },
        editItem (item) {
            var objeto = {
                            opcion         : 'L',
                            idProvincia    : item.idProvincia,
                            idEstado       : item.estado 
                        };

            this.$set(this.listGeneral,'listCantonesModal',[]);

            this.onListar('administrador/canton/listar',objeto,'listCantonesModal')
                .then((respuesta) =>{
                    this.editedIndex = this.listGeneral.detalle.indexOf(item);
                    this.objetAseguradora = _.merge({},this.objetAseguradora,item);

                    if(_.size(item.path) > 0)
                        return this.onListar('administrador/repository-file/listar',{'path': item.path });
                    else
                        return respuesta;
                })
                .then((respuesta) => { 
                    if(_.size(item.path) > 0)
                    this.objetAseguradora.logo = _.size(respuesta.data.data) ? JSON.parse(JSON.stringify(respuesta.data.data)) : null;
                    this.dialog = true; 
                })
                .catch((e) => { mensajesAlerta(e,'E') });
            
        },
        insertarActualizar: function () {
            this.objetAseguradora.opcion = this.editedIndex > -1 ? 'U' : this.objetAseguradora.opcion;
            axios.post(`administrador/aseguradora/insertOrUpdate`,this.objetAseguradora)
                .then((respuesta) => {
                if(respuesta.status != '200' && respuesta.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                if(respuesta.data.existeError) throw respuesta.data.mensaje;
                    mensajeAlertaTiempo(respuesta.data.mensaje,'S');
                    this.close();
                    this.onListarAseguradoras('L');

                }).catch((error) => {
                    mensajesAlerta(error,'E');
                });
        } ,
        close: function () {
            // Reiniciamos las variables
            this.dialog = false;
            this.objetAseguradora = {opcion:'I',estado :'1'};
            this.listGeneral.listCantonesModal = [];
            this.editedIndex = -1;
        },
    },
    provide: function () {
      return {
          close             : this.close,
          save              : this.insertarActualizar,
          onListar          : this.onListar
      }
   }
  }
</script>
